import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { SearchPageTheme } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SearchPageThemeService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public getAllSearchPageThemes(searchPageThemeSearchParam:IGlobalSearchParam):Observable<any> {
      console.log(searchPageThemeSearchParam);
      return this.apiService.post(`SearchPageTheme/SearchSearchPageThemes`,searchPageThemeSearchParam)
    }


    public getSearchPageThemeBySearchPageId(searchPageId:number):Observable<any> {
      return this.apiService.get(`SearchPageTheme/ThemeBySearchPageId/${searchPageId}`)
  }

    public getSearchPageThemeById(themeId:number):Observable<any> {
        return this.apiService.get(`SearchPageTheme/${themeId}`)
    }

    public updateThemeStatus(themeId:number,status:boolean,userId:number):Observable<any> {
      return this.apiService.get(`SearchPageTheme/UpdateThemeStatus?themeId=${themeId}&status=${status}&userId=${userId}`)
  }
     public postSearchPageTheme(searchPageTheme:SearchPageTheme):Observable<any> {
       console.log(searchPageTheme);
        return this.apiService.post(`SearchPageTheme`, searchPageTheme)
    }

     public updateSearchPageTheme(themeId:number, searchPageTheme:SearchPageTheme):Observable<any> {
        return this.apiService.put(`SearchPageTheme/${themeId}`, searchPageTheme)
    }


   
     public deleteSearchPageTheme(themeId:number):Observable<any> {
        return this.apiService.delete(`SearchPageTheme/${themeId}`)
    }

    public ExportSearchPageTheme(searchPageThemeSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}SearchPageTheme/ExportSearchPageThemes`, searchPageThemeSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }

    public checkThemeExists(themeName:string,searchPageLkId:number,userId:number):Observable<any> {
       return this.apiService.get(`SearchPageTheme/CheckThemeExists?themeName=${themeName}&searchPageLkId=${searchPageLkId}&userId=${userId}`)
   }


   public checkSearchPageThemeExists(themeName:string,searchPageLkId:number):Observable<any> {
    return this.apiService.get(`SearchPageTheme/CheckSearchPageThemeExists?themeName=${themeName}&searchPageLkId=${searchPageLkId}`)
}



}
